
import React from 'react';
import axios from 'axios';
import ReactDOM from 'react-dom/client';

import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from './authConfig';

// ---------------------------------------------------
// Environment / Application Type
// ---------------------------------------------------

const isLocalhost =
  window.location.hostname.toLowerCase() === 'localhost';

const currentPath =
  window.location.pathname.toLowerCase();

const isInternalForm =
  currentPath.includes('/internal-forms/');

const isPublicForm =
  currentPath.includes('/public-forms/');

// ---------------------------------------------------
// Axios Configuration
// ---------------------------------------------------

if (isLocalhost) {
  axios.defaults.baseURL =
    'https://localhost:7229/api/';
} else {
  axios.defaults.baseURL =
    window.location.origin + '/PublicFormsWS/api/';
}

axios.defaults.headers.post['Content-Type'] =
  'application/json';

// ---------------------------------------------------
// React
// ---------------------------------------------------

const root = ReactDOM.createRoot(
  document.getElementById('root')
);

// ---------------------------------------------------
// Start Application
// ---------------------------------------------------

async function startApp() {

  // INTERNAL FORMS
  // Uses MSAL authentication and Graph user verification.
  if (isLocalhost || isInternalForm) {

    const msalInstance =
      new PublicClientApplication(msalConfig);

    await msalInstance.initialize();

    root.render(
      <React.StrictMode>
        <MsalProvider instance={msalInstance}>
          <App isInternalSite={true} />
        </MsalProvider>
      </React.StrictMode>
    );

    return;
  }

  // PUBLIC FORMS
  // No MSAL authentication required.
  if (isPublicForm) {

    root.render(
      <React.StrictMode>
        <App isInternalSite={false} />
      </React.StrictMode>
    );

    return;
  }

  // FALLBACK
  // Treat unknown paths as public.
  root.render(
    <React.StrictMode>
      <App isInternalSite={false} />
    </React.StrictMode>
  );
}

startApp();

reportWebVitals();